/* DFF age assurance (10 Oct 2026, brief 9.5). Markup: snippets/dff-age-gate.liquid, dff-age-dob.liquid, dff-age-declaration.liquid.
   The device remembers only "confirmed until" (localStorage 'dff-age-ok-until'), never the date of birth.
   No libraries; works with the native <dialog> (focus stays inside it, Esc closes it, focus returns afterwards). */
(() => {
  const KEY = 'dff-age-ok-until';
  const root = document.documentElement;
  let config = { min: 18, days: 30 };
  try { config = Object.assign(config, JSON.parse(document.getElementById('dff-age-config').textContent)); } catch (e) { /* defaults */ }

  const confirmed = () => { try { return (+localStorage.getItem(KEY) || 0) > Date.now(); } catch (e) { return root.classList.contains('dff-age-ok'); } };

  // Age in whole years on today's date; null when the date is not a real, past date
  const ageFrom = (d, m, y) => {
    d = +d; m = +m; y = +y;
    if (!d || !m || !y) return null;
    const date = new Date(y, m - 1, d);
    if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d || date > new Date()) return null;
    const now = new Date();
    let age = now.getFullYear() - y;
    if (now.getMonth() < m - 1 || (now.getMonth() === m - 1 && now.getDate() < d)) age -= 1;
    return age;
  };
  const read = (scope) => {
    const v = (part) => (scope.querySelector(`[data-dff-dob="${part}"]`) || {}).value;
    return { d: v('day'), m: v('month'), y: v('year') };
  };

  /* The gate */
  const dialog = document.getElementById('dff-age-gate');
  const bar = document.querySelector('[data-dff-age-bar]');
  const needsGate = () => document.body.dataset.dffAge === 'on' || !!document.querySelector('[data-dff-tags~="Over18"]');

  const openGate = () => {
    if (!dialog || dialog.open) return;
    dialog.querySelector('[data-dff-age-step="ask"]').hidden = false;
    dialog.querySelector('[data-dff-age-step="fail"]').hidden = true;
    dialog.showModal();
  };

  if (dialog) {
    const form = dialog.querySelector('[data-dff-age-form]');
    const error = dialog.querySelector('[data-dff-age-error]');
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const { d, m, y } = read(form);
      const age = ageFrom(d, m, y);
      if (age === null) { error.hidden = false; form.querySelector('[data-dff-dob="day"]').focus(); return; }
      error.hidden = true;
      if (age >= config.min) {
        try { localStorage.setItem(KEY, String(Date.now() + config.days * 86400000)); } catch (e) { /* private mode: this page only */ }
        root.classList.add('dff-age-ok');
        if (bar) bar.hidden = true;
        dialog.close();
      } else {
        dialog.querySelector('[data-dff-age-step="ask"]').hidden = true;
        dialog.querySelector('[data-dff-age-step="fail"]').hidden = false;
        dialog.querySelector('[data-dff-age-fail-title]').focus();
      }
      form.reset(); // the date of birth is not kept anywhere
    });
    dialog.querySelector('[data-dff-age-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { if (!confirmed() && bar && needsGate()) bar.hidden = false; });
  }
  document.addEventListener('click', (event) => { if (event.target.closest('[data-dff-age-open]')) openGate(); });

  const start = () => { if (!confirmed() && needsGate()) openGate(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* The basket declaration */
  class DffAgeDeclaration extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.form;
      this.min = +this.dataset.min || config.min;
      this.box = this.querySelector('[data-dff-declare]');
      this.msg = this.querySelector('[data-dff-declare-msg]');
      this.hiddenDob = this.querySelector('[data-dff-dob="value"]');
      this.addEventListener('change', () => this.update(true));
      this.update(false);
    }

    buttons() {
      const form = document.getElementById(this.formId);
      const own = form ? [...form.querySelectorAll('button[name="checkout"]')] : [];
      return own.concat([...document.querySelectorAll(`button[name="checkout"][form="${this.formId}"]`)]);
    }

    update(save) {
      const { d, m, y } = read(this);
      const age = ageFrom(d, m, y);
      const ok = this.box.checked && age !== null && age >= this.min;
      const dob = age === null ? '' : `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      if (this.hiddenDob) this.hiddenDob.value = dob;
      this.toggleAttribute('confirmed', ok);
      this.msg.hidden = ok;
      this.buttons().forEach((button) => { button.disabled = !ok; });
      if (save) {
        const attributes = {};
        attributes[this.box.name.replace(/^attributes\[|\]$/g, '')] = this.box.checked ? this.box.value : '';
        if (this.hiddenDob) attributes[this.hiddenDob.name.replace(/^attributes\[|\]$/g, '')] = ok ? dob : '';
        fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes })
        }).catch(() => { /* the form fields still carry the values on checkout */ });
      }
    }
  }
  if (!customElements.get('dff-age-declaration')) customElements.define('dff-age-declaration', DffAgeDeclaration);
})();
